import { LftSkeleton, LftTypography } from '@lift/design-system-react-web/dist/components';
import React from 'react';
import S from './course-info.styles';
import { CourseInfoProps } from './course-info.types';

const SKELETON_COURSE_TYPE_WIDTH = '142px';
const SKELETON_COURSE_NAME_WIDTH = '212px';

export const CourseInfo: React.FC<CourseInfoProps> = ({ courseType, courseName }) => {
  const renderCourseType = () => {
    if (courseType) {
      return (
        <LftTypography component="caption" size="small" bgColor dataTestId="course-type">
          {`${courseType}:`}
        </LftTypography>
      );
    }

    return (
      <S.SkeletonContainer width={SKELETON_COURSE_TYPE_WIDTH} data-testid="skeleton-course-type">
        <LftSkeleton shape="rectangle" height="16px" />
      </S.SkeletonContainer>
    );
  };

  const renderCourseName = () => {
    if (courseName) {
      return (
        <LftTypography component="paragraph" size="small" fontWeight="bold" bgColor dataTestId="course-name">
          {courseName}
        </LftTypography>
      );
    }

    return (
      <S.SkeletonContainer width={SKELETON_COURSE_NAME_WIDTH} data-testid="skeleton-course-name">
        <LftSkeleton shape="rectangle" height="16px" />
      </S.SkeletonContainer>
    );
  };

  return (
    <S.Container id="course-info">
      {renderCourseType()}
      {renderCourseName()}
    </S.Container>
  );
};
